import { Link } from 'react-router-dom';
import Card from '../shared/Card';
import { Alpha, Beta, Favorite } from '../shared/icons';
import { GAMES_COMPONENT_TITLE } from './Games/Games';

// @TODO improve / clean this up:
// this is currently accessible by anyone (see Routes.js)
// but only visible in the menu to admin (see AppNav.js)

const SitemapCard = ({ title, children }) => (
  <div style={{ width: '300px', margin: '1rem' }}>
    <Card title={title}>
      <ul style={{ listStyle: 'none', paddingLeft: 0 }}>{children}</ul>
    </Card>
  </div>
);

const Sitemap = () => {
  return (
    <div
      style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}
    >
      <SitemapCard title="Pages">
        <li>
          <Link to="/about">About</Link>
        </li>
        <li>
          <Link to="/donate">Donate</Link>
        </li>
        <li>
          <Link to="/">Home</Link>
        </li>
        <li>
          <Link to="/invitecodes">Invite Codes</Link>
        </li>
        <li>
          <Link to="/premium">Premium</Link>
        </li>
        <li>
          <Link to="/settings">Settings</Link>
        </li>
        <li>
          <Link to="/sitemap">Sitemap</Link>
        </li>
      </SitemapCard>

      <SitemapCard title="Public">
        <li>
          <Link to="/community">Community</Link>
        </li>
        <li>
          <Link to="/events">Events</Link> <Beta />
        </li>
        <li>
          <Link to="/public">Public Home</Link>
        </li>
        <li>
          <Link to="/queues">Queues</Link>
        </li>
        <li>
          <Link to="/rooms">Rooms</Link>
        </li>
        <li>
          <Link to="/training">Training</Link> <Favorite />
        </li>
        <li>
          <Link to="/write">Write</Link> <Beta />
        </li>
      </SitemapCard>

      <SitemapCard title="Private">
        <li>
          <Link to="/private">Private Writing</Link> <Favorite />
        </li>
      </SitemapCard>

      <SitemapCard title="Apps">
        <li>
          <Link to="/blog">Blog</Link> <Beta />
        </li>
        <li>
          <Link to="/dashboard">Dashboard</Link> <Alpha />
        </li>
        <li>
          <Link to="/donow">Do Now</Link> <Alpha />
        </li>
        <li>
          <Link to="/lifeoptimizer">Life Optimizer</Link> <Beta />
        </li>
        <li>
          <Link to="/lists">Lists</Link> <Favorite />
        </li>
        <li>
          <Link to="/names">Names</Link> <Beta />
        </li>
        <li>
          <Link to="/scorekeeper">Score Keeper</Link>
        </li>
      </SitemapCard>

      <SitemapCard title="Games">
        <li>
          <Link to="/chess">Chess</Link> <Alpha />
        </li>
        <li>
          <Link to="/cultivation">Cultivation</Link> <Beta />
        </li>
        <li>
          <Link to="/fight-sim">Fight Sim</Link> <Alpha />
        </li>
        <li>
          <Link to="/games">{GAMES_COMPONENT_TITLE}</Link>
          <Favorite />
        </li>
        <li>
          <Link to="/incremental-clicker-game">Incremental Clicker</Link>{' '}
          <Beta />
        </li>
        <li>
          <Link to="/jackbox">Jackbox</Link> <Alpha />
        </li>
        <li>
          <Link to="/tictactoe">Tic-Tac-Toe</Link> <Alpha />
        </li>
        <li>
          <Link to="/time-balls">Time Balls</Link> <Alpha />
        </li>
        <li>
          <Link to="/simcity">Sim City</Link> <Beta />
        </li>
      </SitemapCard>
    </div>
  );
};

export default Sitemap;
